module.exports = __webpack_public_path__ + "img/tablet-screen.874958ef.svg";